import { useState, useContext, useEffect } from 'react';
import { BlockSummaryPaymentCollapsed } from './BlockSummaryPaymentCollapsed';
import { BlockSummaryPaymentNew } from './BlockSummaryPaymentNew';
import { BlockSummaryPaymentSaved } from './BlockSummaryPaymentSaved';
import { getText } from '@educaplay/app-core/language';
import { MainContext } from '../../contexts/main';
import { BlockLoading } from './BlockLoading';
import { PAYMENT_STATUS } from '../../helpers/constants';
import { SVG_info } from '../elements/SVG';
import { isInvitedWithoutSubscription } from '../../helpers/billing';

const InfoNotice = ({ title, body, className = '' }) => {
    return  <div className={`e-notice ${className}`} role="status">
                <span className="e-icon">
                    <SVG_info />
                </span>
                <div className="e-notice__wrapper">
                    <div className="e-notice__text">
                        <div className="e-notice__title">{ getText(title) }</div>
                        <div className="e-notice__body">{ getText(body) }</div>
                    </div>
                </div>
            </div>;
}

export const BlockSummaryPayment = ({ title = 'metodo_de_pago', initialScreen = false, newPaymentMethodTypes = false }) => {

    const { mainReducer } = useContext( MainContext );

    const initialStateScreen = () => {
        if ((mainReducer.state.paymentMethods === false) || (mainReducer.state.currentPaymentMethodNeedsCheck)) {
            return 'loading';
        } else if (initialScreen !== false) {
            return initialScreen;
        } else {
            if ((mainReducer.state.selectedPaymentMethod === false) || (mainReducer.state.newPaymentMethod !== false)) {
                return 'new';
            } else {
                if ((mainReducer.state.currentPaymentMethod !== false) && (mainReducer.state.currentPaymentMethod.id == mainReducer.state.selectedPaymentMethod) && (mainReducer.state.currentPaymentMethod.status == PAYMENT_STATUS.SUCCESS)) {
                    return 'collapsed';
                } else {
                    return 'saved';
                }
            }
        }
    }

    const [ stateScreen, setStateScreen ] = useState('loading');

    const isInvited = isInvitedWithoutSubscription(mainReducer.state);

    const isTeamMemberWithOwnPlan = (mainReducer.state.teamMember === true) && (mainReducer.state.currentLicense.id != 0);

    useEffect( () => {
        if (stateScreen === 'loading') {
            setStateScreen(initialStateScreen());
        }
    }, [ mainReducer.state.paymentMethods, mainReducer.state.currentPaymentMethodNeedsCheck ]);
    return  <>           
            <fieldset className="e__plns__opt__pay">
                <legend>
                    { getText(title) }
                </legend>
                {(isTeamMemberWithOwnPlan) &&
                    <InfoNotice className="mb-lg" title="team_member_own_plan_title" body="team_member_own_plan_body" />
                }
                {(isInvited) ?
                    <InfoNotice title="invited_no_payment_method_title" body="invited_no_payment_method_body" />
                :
                (stateScreen == 'collapsed') ?
                    <BlockSummaryPaymentCollapsed changeScreen={ setStateScreen } />
                :
                    (stateScreen == 'saved') ?
                        <BlockSummaryPaymentSaved changeScreen={ setStateScreen } />
                    :
                        (stateScreen == 'new') ?
                            <BlockSummaryPaymentNew changeScreen={ setStateScreen } types={ newPaymentMethodTypes } />
                        :
                            <BlockLoading />
                }
            </fieldset>
            </>;
}